// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2326":"8c9855fa","5551":"ea3b53a9","7463":"939c24b0","8938":"d27b207a"}[chunkId] + ".chunk.css";
};